module.exports = __webpack_public_path__ + "img/infrasel_2.5ccfe930.png";